import React from "react";
import { Link } from "react-router-dom";
import SearchBox from "./searchBox";
import SenhasTable from "./senhasTable";
import refreshImg from "../img/refresh.svg";
import backImg from "../img/back.svg";

const Senhas = (props) => {
  //const { senhas, sortColumn, onSort, searchQuery, onChangeQuery } = props;
  const { senhas, sortColumn, onSort, searchQuery, onChangeQuery, onClickTotalSenhas } = props;

  let filteredSenhas = senhas;

  if (props.match.params.id)
    filteredSenhas = senhas.filter(
      (s) => s.cod_sala === parseInt(props.match.params.id)
    );

  const totalSenhas = filteredSenhas.length ? `${filteredSenhas.length}` : "0";

  const sala_act = props.match.params.id
    ? filteredSenhas.map((s, index) => {
        if (index === 0)
          return (
            <p  key={index}>                                            {/* 2020-10-28 <p> */}
              S: {s.sala_text} | A: {s.actividade_text} | {"H: "}
              <strong>{s.hora_actividade}</strong>
            </p>
          );
      })
    : "";

  return (
    <div>
      
      <h5>reserva/senha(s)</h5>
      <span>{props.match.params.id ? sala_act : ""}</span>
      <h3>
        <Link to="/"><img src={backImg} alt="back" /></Link>
        <span className="badge badge-info" style={{marginLeft : "20px", marginRight : "20px"}}>{totalSenhas}</span>
        <img src={refreshImg} onClick={onClickTotalSenhas} style={{cursor: "pointer"}} alt="refresh" />
      </h3>
      <SearchBox value={searchQuery} onChange={onChangeQuery} />
      <SenhasTable
        senhas={filteredSenhas}
        sortColumn={sortColumn}
        onSort={onSort}
        espacos_todos={props.match.params.id ? false : true}
      />
    </div>
  );
};

export default Senhas;
